export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11898.558a55c6.jpg";